import { render, staticRenderFns } from "./SalesRevenue.vue?vue&type=template&id=2db67974"
import script from "./SalesRevenue.vue?vue&type=script&lang=js"
export * from "./SalesRevenue.vue?vue&type=script&lang=js"
import style0 from "./SalesRevenue.vue?vue&type=style&index=0&id=2db67974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports